import {
  Box,
  Button,
  Image,
  Progress,
  Stack,
  Text,
  VStack,
} from "@chakra-ui/react";
import React from "react";
import { Img } from "../../../../content/Content";
import { GoArrowUpRight } from "react-icons/go";

import "./Course.component.css";
const Course = () => {
  const CourseBox = [
    {
      name: "Learn forex trending polish",
      logo: Img.chanelLogo1,
      pic: Img.course1,
    },
    {
      name: "Learn forex trending polish",
      logo: Img.chanelLogo2,
      pic: Img.course2,
    },
    {
      name: "Learn forex trending polish",
      logo: Img.chanelLogo3,
      pic: Img.course3,
    },
    {
      name: "Learn forex trending polish",
      logo: Img.chanelLogo4,
      pic: Img.course4,
    },
    {
      name: "Learn forex trending polish",
      logo: Img.chanelLogo6,
      pic: Img.course1,
      active: true,
    },
    {
      name: "Learn forex trending polish",
      logo: Img.chanelLogo5,
      pic: Img.course1,
    },
    {
      name: "Learn forex trending polish",
      logo: Img.chanelLogo5,
      pic: Img.course1,
    },
    {
      name: "Learn forex trending polish",
      logo: Img.chanelLogo5,
      pic: Img.course2,
    },
    {
      name: "Learn forex trending polish",
      logo: Img.chanelLogo5,
      pic: Img.course1,
    },
  ];

  return (
    <VStack bgColor="rgba(245, 245, 255, 1)">
      {/* desktop-version */}
      <Box w="100%" mx="auto">
        {/* all boxes */}
        <Stack
          flexDir="row"
          p="0"
          m="0"
          justifyContent="flex-start"
          alignItems="center"
          flexWrap="wrap"
          w={"100%"}
          gap={"0"}
        >
          {CourseBox.map((item) => {
            return (
              <Stack
                w="33%"
                p="0"
                m="0"
                my="10px"
                overflow={"hidden"}
                h="322px"
                borderRadius="15px"
              >
                <Box
                  bg={"rgba(255, 255, 255, 1)"}
                  borderRadius="20px"
                  p="20px"
                  m="10px"
                  transition="0.3s all ease-in"
                >
                  {/* top-bar */}
                  <Stack flexDir="row">
                    <Box
                      w="70%"
                      h={"auto"}
                      display={"flex"}
                      alignItems={"center"}
                    >
                      <Image
                        src={item.logo}
                        alt="chanelLogo1"
                        height={"53px"}
                        w="62px"
                      />
                    </Box>
                    <Box
                      w="30%"
                      display={"flex"}
                      justifyContent={"flex-end"}
                      alignItems={"center"}
                    >
                      <Box
                        bg="rgba(234, 234, 234, 1)"
                        height={"45px"}
                        w="45px"
                        borderRadius="90px"
                        display={"flex"}
                        justifyContent={"center"}
                        alignItems={"center"}
                      >
                        <GoArrowUpRight style={{ fontSize: "24px" }} />
                      </Box>
                    </Box>
                  </Stack>
                  {/* title */}
                  <Stack my="4">
                    <Text
                      className="title"
                      fontSize="20px"
                      fontWeight={"500"}
                      color={"rgba(149, 151, 171, 1)"}
                      lineHeight={"16px"}
                      py="15px"
                      fontFamily={"'Roboto', sans-serif"}
                    >
                      {item.name}
                    </Text>
                  </Stack>

                  {/* cover Image */}
                  <Stack height="233px" overflow="hidden">
                    <Image
                      src={item.pic}
                      alt="cover"
                      w="100%"
                      h="auto"
                      borderRadius={"30px"}
                    />
                  </Stack>
                </Box>
              </Stack>
            );
          })}
        </Stack>
        <Stack py="25px">
          {/* Pagination */}
          <Box display="flex" justifyContent="end">
            <Button
              h="31px"
              width="31px"
              borderRadius="8px"
              bg="rgba(255, 255, 255, 1)"
              color="rgba(158, 158, 158, 1)"
              fontFamily="'Poppins', sans-serif"
              display="flex"
              alignItems="center"
              justifyContent="center"
              fontWeight="400"
              fontSize="14px"
              mx="5px"
            >
              1
            </Button>
            <Button
              h="31px"
              width="31px"
              borderRadius="8px"
              bg="rgba(149, 151, 171, 1)"
              color="rgba(255, 255, 255, 1)"
              fontFamily="'Poppins', sans-serif"
              display="flex"
              alignItems="center"
              justifyContent="center"
              fontWeight="400"
              fontSize="14px"
              mx="5px"
            >
              2
            </Button>
            <Button
              h="31px"
              width="31px"
              borderRadius="8px"
              bg="rgba(149, 151, 171, 1)"
              color="rgba(255, 255, 255, 1)"
              fontFamily="'Poppins', sans-serif"
              display="flex"
              alignItems="center"
              justifyContent="center"
              fontWeight="400"
              fontSize="14px"
              mx="5px"
            >
              3
            </Button>
            <Button
              h="31px"
              width="31px"
              borderRadius="8px"
              bg="rgba(149, 151, 171, 1)"
              color="rgba(255, 255, 255, 1)"
              fontFamily="'Poppins', sans-serif"
              display="flex"
              alignItems="center"
              justifyContent="center"
              fontWeight="400"
              fontSize="14px"
              mx="5px"
            >
              4
            </Button>
            <Button
              h="31px"
              width="31px"
              borderRadius="8px"
              bg="rgba(149, 151, 171, 1)"
              color="rgba(255, 255, 255, 1)"
              fontFamily="'Poppins', sans-serif"
              display="flex"
              alignItems="center"
              justifyContent="center"
              fontWeight="400"
              fontSize="14px"
              mx="5px"
            >
              5
            </Button>
            <Button
              h="31px"
              width="31px"
              borderRadius="8px"
              bg="rgba(149, 151, 171, 1)"
              color="rgba(255, 255, 255, 1)"
              fontFamily="'Poppins', sans-serif"
              display="flex"
              alignItems="center"
              justifyContent="center"
              fontWeight="400"
              fontSize="14px"
              mx="5px"
            >
              ...
            </Button>
            <Button
              h="31px"
              width="31px"
              borderRadius="8px"
              bg="rgba(149, 151, 171, 1)"
              color="rgba(255, 255, 255, 1)"
              fontFamily="'Poppins', sans-serif"
              display="flex"
              alignItems="center"
              justifyContent="center"
              fontWeight="400"
              fontSize="14px"
              mx="5px"
            >
              17
            </Button>
          </Box>
        </Stack>
        <Stack>
          <Text
            fontFamily="'Roboto', sans-serif"
            fontSize="24px"
            fontWeight="700"
            color="rgba(181, 181, 195, 1)"
          >
            Progress
          </Text>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <Text
              fontFamily="'Poppins', sans-serif"
              fontSize="16px"
              fontWeight="500"
              color="rgba(181, 181, 195, 1)"
            >
              More than 400+ new course
            </Text>
            <Box>
              <Button
                bg="transparent"
                _hover={{
                  bg: "transparent",
                }}
                fontFamily="'Poppins', sans-serif"
                fontSize="16px"
                fontWeight="500"
                color="rgba(181, 181, 195, 1)"
              >
                Month
              </Button>
              <Button
                bg="transparent"
                _hover={{
                  bg: "transparent",
                }}
                fontFamily="'Poppins', sans-serif"
                fontSize="16px"
                fontWeight="500"
                color="rgba(181, 181, 195, 1)"
              >
                Week
              </Button>
              <Button
                bg="rgba(63, 66, 84, 1)"
                fontFamily="'Poppins', sans-serif"
                fontSize="16px"
                fontWeight="600"
                color="rgba(255, 255, 255, 1)"
              >
                Day
              </Button>
            </Box>
          </Box>
        </Stack>
        {/* progress bar */}
        <Stack p="25px" borderRadius="27px" bg="rgba(255, 255, 255, 1)" my="30px">
          <Stack flexDir="row" pb="20px">
            <Box display="flex" alignItems="center" w="60%">
              <Image src={Img.play} w="21.67px" h="21.67px" mr="20px" />
              <Text
                fontFamily="'Roboto', sans-serif"
                fontSize="20px"
                fontWeight="500"
                color="rgba(101, 102, 115, 1)"
              >
                FRX101- introductions ti trade overview
              </Text>
            </Box>
            <Box w="40%">
              <Box w="100%" display="flex" justifyContent="space-between">
                <Text
                  fontFamily="'Roboto', sans-serif"
                  fontSize="14px"
                  fontWeight="700"
                  color="rgba(181, 181, 195, 1)"
                >
                  1000%
                </Text>
                <Text
                  fontFamily="'Roboto', sans-serif"
                  fontSize="14px"
                  fontWeight="700"
                  color="rgba(181, 181, 195, 1)"
                >
                  Completed
                </Text>
              </Box>
              <Progress
                value={100}
                size="xs"
                color="rgba(6, 194, 149, 1)"
                my="10px"
              />
            </Box>
          </Stack>
          <Stack flexDir="row" pb="20px">
            <Box display="flex" alignItems="center" w="60%">
              <Image src={Img.play} w="21.67px" h="21.67px" mr="20px" />
              <Text
                fontFamily="'Roboto', sans-serif"
                fontSize="20px"
                fontWeight="500"
                color="rgba(101, 102, 115, 1)"
              >
                FRX102-pips, lots & unite
              </Text>
            </Box>
            <Box w="40%">
              <Box w="100%" display="flex" justifyContent="space-between">
                <Text
                  fontFamily="'Roboto', sans-serif"
                  fontSize="14px"
                  fontWeight="700"
                  color="rgba(181, 181, 195, 1)"
                >
                  20%
                </Text>
                <Text
                  fontFamily="'Roboto', sans-serif"
                  fontSize="14px"
                  fontWeight="700"
                  color="rgba(181, 181, 195, 1)"
                >
                  Progress
                </Text>
              </Box>
              <Progress
                value={20}
                size="xs"
                color="rgba(54, 153, 255, 1)"
                my="10px"
              />
            </Box>
          </Stack>

          <Stack flexDir="row" pb="20px">
            <Box display="flex" alignItems="center" w="60%">
              <Image src={Img.play} w="21.67px" h="21.67px" mr="20px" />
              <Text
                fontFamily="'Roboto', sans-serif"
                fontSize="20px"
                fontWeight="500"
                color="rgba(101, 102, 115, 1)"
              >
                FRX102-pips, lots & unite
              </Text>
            </Box>
            <Box w="40%">
              <Box w="100%" display="flex" justifyContent="space-between">
                <Text
                  fontFamily="'Roboto', sans-serif"
                  fontSize="14px"
                  fontWeight="700"
                  color="rgba(181, 181, 195, 1)"
                >
                  00%
                </Text>
                <Text
                  fontFamily="'Roboto', sans-serif"
                  fontSize="14px"
                  fontWeight="700"
                  color="rgba(181, 181, 195, 1)"
                >
                  Progress
                </Text>
              </Box>
              <Progress
                value={0}
                size="xs"
                color="rgba(54, 153, 255, 1)"
                my="10px"
              />
            </Box>
          </Stack>
        </Stack>

        {/* progress bar */}
      </Box>
    </VStack>
  );
};

export default Course;
